import { Injectable } from '@angular/core';
import { LoggingService } from '@com-delta-idp/mnx-utils';
import {
  ILoginUserNamePasswordInput,
  LoginAuthWithCredentials,
  LoginOAuth,
  OauthAEMConfig,
  PkceCode,
  SwapAuthForAccessTokens,
  SwapAuthForAccessTokensParams
} from '../../models';
import { PostWithCredService } from '../remember-me-adapter-service/post-with-cred/post-with-cred-service';
import { SwapAccessTokenService } from '../swap-access-token-service/swap-access-token-service';
import { UtilMethodsHelperService } from '../util-service/util-methods-helper.service';
import { UtilService } from '../util-service/util-service';

@Injectable({
  providedIn: 'root'
})
export class TokenHelperService {
  loginOAuth!: LoginOAuth;
  loginAuthWithCredentials!: LoginAuthWithCredentials;
  swapAuthForAccessTokens!: SwapAuthForAccessTokens;

  constructor(
    protected utils: UtilService,
    protected utilMethodsHelper: UtilMethodsHelperService,
    protected postWithCred: PostWithCredService,
    protected swapAuthForAccessTokenService: SwapAccessTokenService,
    protected logging: LoggingService
  ) {}

  isCompletedStatus(config: OauthAEMConfig) {
    return (
      this.loginAuthWithCredentials?.status === config.COMPLETED ||
      this.loginOAuth?.status === config.COMPLETED
    );
  }

  isUserNamePasswordStatus(config: OauthAEMConfig) {
    return (
      this.loginOAuth?.id &&
      this.loginOAuth?.status === config.USERNAME_PASSWORD_REQUIRED
    );
  }

  setAuthCode() {
    return (
      this.loginAuthWithCredentials?.authorizeResponse?.code ||
      this.loginOAuth?.authorizeResponse?.code ||
      ''
    );
  }

  async loginOauthHelper(
    config: OauthAEMConfig,
    requestInput: ILoginUserNamePasswordInput
  ) {
    if (this.isUserNamePasswordStatus(config)) {
      this.loginAuthWithCredentials =
        await this.postWithCred.postWithCredentials(
          config,
          this.loginOAuth.id,
          requestInput
        );
    } else if (this.utils.isAuthErrorResponse(this.loginOAuth)) {
      const errorId = this.utils.populatePingErrorResponse(this.loginOAuth);
      return {
        ...this.loginOAuth,
        errorId: errorId
      };
    } else {
      return this.logging.log('invalid response for loginOAuth');
    }
  }

  async loginAuthWithCredentialsHelper(
    config: OauthAEMConfig,
    pkceCode: PkceCode
  ) {
    const swapAuthForAccessTokensParams: SwapAuthForAccessTokensParams = {
      authorizationCode: this.setAuthCode(),
      oauthConfig: config,
      pkcCodeGenerated: pkceCode
    };

    this.swapAuthForAccessTokens =
      await this.swapAuthForAccessTokenService.swapAuthForAccessTokens(
        swapAuthForAccessTokensParams
      );

    if (
      this.swapAuthForAccessTokens?.access_token &&
      this.swapAuthForAccessTokens?.expires_in
    ) {
      const tokenResponse = {
        access_token: this.swapAuthForAccessTokens.access_token,
        expires_in: this.swapAuthForAccessTokens.expires_in
      };
      this.utilMethodsHelper.sendTokenServiceWorker(config, tokenResponse);
      return this.swapAuthForAccessTokens;
    } else if (this.utils.isAuthErrorResponse(this.swapAuthForAccessTokens)) {
      const errorId = this.utils.populatePingErrorResponse(
        this.swapAuthForAccessTokens
      );
      return {
        ...this.swapAuthForAccessTokens,
        errorId: errorId
      };
    } else {
      return this.logging.log('invalid response for swapAuthForAccessTokens');
    }
  }
}
